import { render, staticRenderFns } from "./MaterialsJournal.vue?vue&type=template&id=37bdd757&scoped=true"
import script from "./MaterialsJournal.vue?vue&type=script&lang=js"
export * from "./MaterialsJournal.vue?vue&type=script&lang=js"
import style0 from "./MaterialsJournal.vue?vue&type=style&index=0&id=37bdd757&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bdd757",
  null
  
)

export default component.exports